import { Button, Loading } from '../../../../components';
import { useMutation } from '@apollo/client';
import { FINALIZE_PLAN } from '../../queries';
import { lastUpdateDateFormatter } from '../../../../utils';
import { message } from 'antd';

interface FinalizeLocationBcpProps {
  lastUpdate: string;
  uuid: string;
  isCorporate: boolean;
  onClose: (updatedValue: string) => void;
}

type FinalizePlanData = {
  lastUpdate: string;
  uuid: string;
};

interface ResponseData {
  finalizePlan: FinalizePlanData;
}

export function FinalizeLocationBcp({
  lastUpdate,
  isCorporate,
  uuid,
  onClose,
}: FinalizeLocationBcpProps) {
  const [FinalizePlan, { loading }] = useMutation<ResponseData>(FINALIZE_PLAN, {
    refetchQueries: [
      'FindAllLocations',
      'FindAllStrategiesByLocation',
      'FetchStrategySummary',
    ],
  });

  const handleClick = async () => {
    try {
      const result = await FinalizePlan({
        variables: {
          data: {
            uuid,
            bcpStatus: 'Finalized',
            finalizedAt: new Date().toISOString(),
          },
        },
      });

      if (result.data) {
        onClose(result.data.finalizePlan.lastUpdate!);
        message.success('Successfully refreshed items');
      }
    } catch (error) {
      console.log(error);
      message.error('Failed to refresh items');
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col flex-nowrap items-center justify-center">
      <p className="my-2   text-sm font-normal text-black tracking-wider text-center">
        Refreshing the {isCorporate ? 'corporate' : 'location'} items will date
        stamp the BCP with today’s date and reset the update timer. Note that
        this action will not reset the timer of the individual mitigation
        strategies.
      </p>
      <h3 className="my-2   text-sm font-bold text-black tracking-wider text-center">
        LAST UPDATE:{' '}
        {lastUpdate === 'NEVER'
          ? lastUpdate
          : lastUpdateDateFormatter(lastUpdate)}
      </h3>
      <Button
        type="primary"
        htmlType={'button'}
        className="min-w-[180px] mt-4 text-sm py-3"
        onClick={handleClick}
      >
        Confirm Refresh
      </Button>
    </div>
  );
}
